import { combineReducers } from 'redux';
import selectedExpirationReducer from './selectedExpirationReducer';
import appStateReducer from './appStateReducer';
import optionChainStateReducer from './optionChainStateReducer';
import UOAState from './UOAState';
import OpenInterestState from './openInterestState';

export default combineReducers({
  selectedExpiration: selectedExpirationReducer,
  appReducer:appStateReducer,
  optionChainReducer:optionChainStateReducer,
  UOAState,
  OpenInterestState
});



// WEBPACK FOOTER //
// ./src/reducers/index.js